export default "__VITE_ASSET__oEm2SQ6T__"